"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayConnectionSummaryEntity = exports.DisplayConnectionDisplaySummaryEntity = exports.DisplayConnectionHourlySummaryEntity = exports.DisplayConnectionEvidenceIntervalEntity = void 0;
const swagger_1 = require("@nestjs/swagger");
class DisplayConnectionEvidenceIntervalEntity {
    from;
    to;
    connected;
}
exports.DisplayConnectionEvidenceIntervalEntity = DisplayConnectionEvidenceIntervalEntity;
__decorate([
    (0, swagger_1.ApiProperty)({ format: "date-time" }),
    __metadata("design:type", String)
], DisplayConnectionEvidenceIntervalEntity.prototype, "from", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ format: "date-time" }),
    __metadata("design:type", String)
], DisplayConnectionEvidenceIntervalEntity.prototype, "to", void 0);
__decorate([
    (0, swagger_1.ApiProperty)(),
    __metadata("design:type", Boolean)
], DisplayConnectionEvidenceIntervalEntity.prototype, "connected", void 0);
class DisplayConnectionHourlySummaryEntity {
    displayId;
    bucketStart;
    connectedSeconds;
    evidenceSeconds;
    evidenceIntervals;
    source;
    confidence;
}
exports.DisplayConnectionHourlySummaryEntity = DisplayConnectionHourlySummaryEntity;
__decorate([
    (0, swagger_1.ApiProperty)(),
    __metadata("design:type", String)
], DisplayConnectionHourlySummaryEntity.prototype, "displayId", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ format: "date-time", description: "Inicio de la hora en UTC" }),
    __metadata("design:type", String)
], DisplayConnectionHourlySummaryEntity.prototype, "bucketStart", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Segundos de conexión atribuidos a la hora" }),
    __metadata("design:type", Number)
], DisplayConnectionHourlySummaryEntity.prototype, "connectedSeconds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ description: "Segundos con evidencia de actividad o conectividad" }),
    __metadata("design:type", Number)
], DisplayConnectionHourlySummaryEntity.prototype, "evidenceSeconds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        type: [DisplayConnectionEvidenceIntervalEntity],
        description: "Intervalos de evidencia; el histórico acumulado devuelve una lista vacía",
    }),
    __metadata("design:type", Array)
], DisplayConnectionHourlySummaryEntity.prototype, "evidenceIntervals", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        enum: ["connectivity_events", "activity_events", "last_connection_fallback", "unavailable"],
    }),
    __metadata("design:type", String)
], DisplayConnectionHourlySummaryEntity.prototype, "source", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ enum: ["high", "medium", "low", "none"] }),
    __metadata("design:type", String)
], DisplayConnectionHourlySummaryEntity.prototype, "confidence", void 0);
class DisplayConnectionDisplaySummaryEntity {
    displayId;
    connectedSeconds;
    source;
    confidence;
}
exports.DisplayConnectionDisplaySummaryEntity = DisplayConnectionDisplaySummaryEntity;
__decorate([
    (0, swagger_1.ApiProperty)(),
    __metadata("design:type", String)
], DisplayConnectionDisplaySummaryEntity.prototype, "displayId", void 0);
__decorate([
    (0, swagger_1.ApiProperty)(),
    __metadata("design:type", Number)
], DisplayConnectionDisplaySummaryEntity.prototype, "connectedSeconds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        enum: ["connectivity_events", "activity_events", "last_connection_fallback", "unavailable"],
    }),
    __metadata("design:type", String)
], DisplayConnectionDisplaySummaryEntity.prototype, "source", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ enum: ["high", "medium", "low", "none"] }),
    __metadata("design:type", String)
], DisplayConnectionDisplaySummaryEntity.prototype, "confidence", void 0);
class DisplayConnectionSummaryEntity {
    displayIds;
    from;
    to;
    bucketSeconds;
    hourly;
    byDisplay;
}
exports.DisplayConnectionSummaryEntity = DisplayConnectionSummaryEntity;
__decorate([
    (0, swagger_1.ApiProperty)({ type: [String] }),
    __metadata("design:type", Array)
], DisplayConnectionSummaryEntity.prototype, "displayIds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ format: "date-time" }),
    __metadata("design:type", String)
], DisplayConnectionSummaryEntity.prototype, "from", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ format: "date-time" }),
    __metadata("design:type", String)
], DisplayConnectionSummaryEntity.prototype, "to", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ example: 3600, description: "Duración de cada tramo en segundos" }),
    __metadata("design:type", Number)
], DisplayConnectionSummaryEntity.prototype, "bucketSeconds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ type: [DisplayConnectionHourlySummaryEntity] }),
    __metadata("design:type", Array)
], DisplayConnectionSummaryEntity.prototype, "hourly", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({ type: [DisplayConnectionDisplaySummaryEntity] }),
    __metadata("design:type", Array)
], DisplayConnectionSummaryEntity.prototype, "byDisplay", void 0);
